<q9-button-toggle-group [(ngModel)]="selectedTab" (change)="onTabChange()">
  <q9-button-toggle [value]="SUB_TABS.PlannedChangesTab">
    {{ 'CORE.SIDEBAR.PLANNED_CHANGES_TAB' | translate }}
    <span class="q9-counter">{{ planedChangesTabCount() }}</span>
  </q9-button-toggle>
  <q9-button-toggle [value]="SUB_TABS.FeedbackTab">
    {{ 'SIDEBAR.FEEDBACK_TAB' | translate }}
    <span class="q9-counter">{{ feedbackTabCount() }}</span>
  </q9-button-toggle>
</q9-button-toggle-group>

<ng-template [cdkPortalOutlet]="tabPortal"></ng-template>
